import { GET_LANGUAGE, GET_LANGUAGE_ERROR } from "../../actions/masterData";


const initState = {
    data: [],
    error: null,
    status: null,
    currentlogedInuser: null,
};

export const languageReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_LANGUAGE:
            return {
                ...state,
                languageList: {
                    data: action?.payload,
                    status: action?.payload?.data?.status,
                    error: null,
                },
            };
        case GET_LANGUAGE_ERROR:
            return {
                ...state,
                languageList: {
                    data: action?.payload,
                    status: action?.payload?.state,
                    error: null,
                },
            };
        default:
            return state;
    }
};
